import LotNotFoundSVG from "./icons/LotNotFoundSVG";
import { Box, Typography, Paragraph } from "@bca/ui-library";
import styled from "styled-components";
import { layout, LayoutProps } from "styled-system";

interface StyledProps extends LayoutProps {}

const ZeroResultTitle = styled(Typography)<StyledProps>`
  ${layout}
`;

interface ZeroResultsProps {
  title: string;
}

const ZeroResults: React.FunctionComponent<ZeroResultsProps> = ({ title }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
      marginBottom={{ mobile: "130px", tablet: "106px", desktop: "125px" }}
    >
      <LotNotFoundSVG width="64px" height="64px" />
      <ZeroResultTitle
        color="footer-blue"
        variant="h4"
        my="0"
        textAlign="center"
        css={`
          margin-top: 16px;
        `}
        maxWidth={{ mobile: "100%", tablet: "478px", desktop: "539px" }}
      >
        {title}
      </ZeroResultTitle>
      <Paragraph
        textAlign="center"
        fontSize="18px"
        lineHeight="1.4"
        color="grey-blue"
        marginTop="11px"
        maxWidth={{ mobile: "100%", tablet: "478px", desktop: "539px" }}
      >
        Sorry, we were unable to find any matching vehicles. Please try a
        different Vehicle Reg, set of keywords or combination of filters.
      </Paragraph>
    </Box>
  );
};

export default ZeroResults;
